export const VAT_RATE_MUTATION = `
mutation() {}
`
